import React, { useState } from "react";
import "./download.css"; // external CSS
import kitchenImg from "../../assets/banner/empty-modern-room-with-furniture.jpg"; 
import { FaDownload } from "react-icons/fa";
import Popupboxx from "../popupboxx/Popupboxx";

function Download() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    
    <div className="download-section">
      <div className="download-container">
        {/* Left Side Image */}
        <div className="download-image">
          <img src={kitchenImg} alt="Kitchen" />
        </div>

        {/* Right Side Content */}
        <div className="download-content">
          <h2>Transform Your Home with Smart Design Secrets</h2>
          <p>
            Unlock expert tips to craft interiors that are stylish, practical, and timeless. 💡 Download our free guide today and design your dream home with confidence.
          </p>
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>
            <span className="icon"><FaDownload/> </span> Download Free Guide
          </button>
        </div>
      </div>
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </div>
  );
}

export default Download;

